import React, { useState, useEffect } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import api, { formatApiErrorDetail } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { LOGO_URL } from "@/data/brand";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token");
  const isClaim = params.get("claim") === "1";
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);
  const { refresh } = useAuth();
  const nav = useNavigate();

  useEffect(() => {
    if (!token) { toast.error("Token mancante"); nav("/recupera-password"); }
  }, [token, nav]);

  const submit = async (e) => {
    e.preventDefault();
    if (password !== confirm) { toast.error("Le password non coincidono"); return; }
    if (password.length < 6) { toast.error("Almeno 6 caratteri"); return; }
    setLoading(true);
    try {
      const { data } = await api.post("/auth/reset-password", { token, password });
      localStorage.setItem("hm_token", data.access_token);
      await refresh();
      toast.success(isClaim ? "Account rivendicato! Benvenuto." : "Password aggiornata");
      nav("/dashboard");
    } catch (e) {
      toast.error(formatApiErrorDetail(e.response?.data?.detail) || "Errore");
    } finally { setLoading(false); }
  };

  return (
    <div className="max-w-md mx-auto px-4 md:px-8 py-20" data-testid="reset-password-page">
      <Link to="/"><img src={LOGO_URL} alt="HostMarket" className="h-10 w-auto mb-10" /></Link>
      <h1 className="font-heading font-black text-3xl mb-2">{isClaim ? "Rivendica i tuoi annunci" : "Imposta nuova password"}</h1>
      <p className="text-sm text-zinc-500 mb-8">{isClaim ? "Imposta una password per accedere e gestire i tuoi annunci migrati da HostMarket." : "Inserisci la nuova password per il tuo account."}</p>
      <form onSubmit={submit} className="space-y-4" data-testid="reset-form">
        <div>
          <label className="text-xs uppercase tracking-wider text-zinc-500 mb-2 block">Nuova password <span className="text-zinc-600">(min 6 caratteri)</span></label>
          <input required minLength={6} type="password" value={password} onChange={(e) => setPassword(e.target.value)} className="w-full bg-[#0A0A0A] border border-zinc-800 rounded-md px-4 py-3 text-sm focus:border-[#E619A8] focus:ring-1 focus:ring-[#E619A8] outline-none" data-testid="reset-password-input" />
        </div>
        <div>
          <label className="text-xs uppercase tracking-wider text-zinc-500 mb-2 block">Conferma password</label>
          <input required minLength={6} type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} className="w-full bg-[#0A0A0A] border border-zinc-800 rounded-md px-4 py-3 text-sm focus:border-[#E619A8] focus:ring-1 focus:ring-[#E619A8] outline-none" data-testid="reset-confirm-input" />
        </div>
        <button type="submit" disabled={loading} className="w-full py-3 rounded-md bg-[#E619A8] text-white font-bold uppercase tracking-wider text-sm hover:bg-[#FFBE00] hover:text-black transition-all disabled:opacity-50" data-testid="reset-submit">
          {loading ? "Salvataggio…" : (isClaim ? "Rivendica e accedi" : "Salva nuova password")}
        </button>
      </form>
    </div>
  );
}
